export default "__VITE_ASSET__XMYWFhOS__"